var map = {
	"./aws/logo.png": "kICK",
	"./cathay-united-bank/logo.png": "pZF2",
	"./conquer-tech/logo.png": "g7IH",
	"./ctbc-bank/logo.png": "uH2q",
	"./e-cloud-valley/logo.png": "FYue",
	"./fable/logo.png": "am0A",
	"./jet-brains/logo.png": "I1qM",
	"./red-hat/logo.png": "JmDO",
	"./soft-leader/logo.png": "/Kjf"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "L/Fq";